import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledColumnOption, StyledDragIcon, StyledIconButton } from "../ColumnOptionView/styles";

export const StyledColumnOptionsListWrapper = styled.div`
    padding: 16px 16px 8px 16px;
`;

/**
 * The virtualised list's counterpart. Vertical padding is deliberately absent — the virtualiser owns
 * it via `paddingStart`/`paddingEnd` so that its coordinate space matches the container's `scrollTop`.
 */
export const StyledColumnOptionsVirtualWrapper = styled.div`
    padding: 0 16px;
`;

/**
 * Holds the scroll container and the two edge indicators. The indicators have to live outside the
 * scroller — pinned to it rather than scrolling with it — without contributing height to it.
 */
export const StyledColumnOptionsViewport = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const StyledColumnOptionsList = styled.div`
    position: relative;
    flex-grow: 1;
    overflow: auto;
    overscroll-behavior: contain;

    &.dragging {
        ${StyledColumnOption} {
            &:hover {
                ${StyledIconButton} {
                    opacity: 0;
                }

                ${StyledDragIcon} {
                    fill: ${colorsPalettes.carbon[200]};
                }
            }
        }
    }
`;

export const StyledColumnOptionsTrack = styled.div<{ expandVertically?: boolean }>`
    display: flex;
    flex-direction: column;

    ${(p) =>
        p.expandVertically &&
        css`
            margin: -6px 0;
        `}
    > * {
        :hover {
            z-index: 1;
        }
    }
`;

/**
 * Establishes the containing block for the absolutely positioned virtual rows, and reserves the full
 * scroll height so the scrollbar reflects the whole list rather than the rendered window.
 */
export const StyledColumnOptionsVirtualTrack = styled.div`
    position: relative;
    width: 100%;
`;
